import React from 'react'
import ErrorDisplay from './ErrorDisplay'
import AccessDenied from './AccessDenied'

interface ErrorBoundaryState {
  hasError: boolean
  error?: Error
}

interface ErrorBoundaryProps {
  children: React.ReactNode
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  private isAuthError(error: Error): boolean {
    return error.message.includes('Unauthorized') || 
           error.message.includes('Authentication required') ||
           error.message.includes('Access denied')
  }

  render() {
    if (this.state.hasError && this.state.error) {
      // Handle authorization errors with professional UI
      if (this.isAuthError(this.state.error)) {
        return (
          <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ErrorDisplay
              error={this.state.error}
              onRetry={() => window.location.reload()}
            />
          </div>
        )
      }

      // Handle other errors with generic error display
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <ErrorDisplay
            error={this.state.error}
            onRetry={() => window.location.reload()}
          />
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary